import {
  observer
} from 'mobx-react-lite';
import type { ApplicationSdk } from '../stores';
import NewOrder from './cleaner/NewOrder';
import TrainingComponent from './cleaner/TrainingComponent';

const CleanerView = observer(({ sdk }: { sdk: ApplicationSdk }) => {
  return <>
    {sdk.locationAction === 'neworder' ? <NewOrder sdk={sdk} /> : null}
    {sdk.locationAction === 'training' ? <TrainingComponent sdk={sdk} /> : null}
  </>
});

export default CleanerView;